"use client";

import { c as _c } from "react/compiler-runtime";
import { useLocaleContext } from "@/app/i18n/client";
import { Libraries, useLoadScriptLazy } from "@/utils/hooks/use-loadscript-lazy";
import { createContext, useContext, useState } from "react";

// Muss global const sein, sonst wird die google map api jedes mal neu geladen
const libraries = ["places"] as Libraries;
type GoogleMapsContext = {
  isLoaded: boolean;
  loadNow: () => void;
  loadError: Error | undefined;
};
export const GoogleMapsContext = createContext<GoogleMapsContext | null>(null);
export function GoogleMapsProvider(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const lng = useLocaleContext();
  const [shouldLoad, setShouldLoad] = useState(false);
  let t1;
  if ($[0] !== lng || $[1] !== shouldLoad) {
    t1 = {
      googleMapsApiKey: "AIzaSyCuRFwBvHxBGA3pfCqbCRx_URlr3js5Uzc",
      region: "EU",
      language: lng,
      libraries,
      preventGoogleFontsLoading: true,
      loadNow: shouldLoad
    };
    $[0] = lng;
    $[1] = shouldLoad;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const loadScript = useLoadScriptLazy(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setShouldLoad(true);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== loadScript.isLoaded || $[5] !== loadScript.loadError) {
    t3 = {
      isLoaded: loadScript.isLoaded,
      loadNow: t2,
      loadError: loadScript.loadError
    };
    $[4] = loadScript.isLoaded;
    $[5] = loadScript.loadError;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== t3) {
    t4 = <GoogleMapsContext.Provider value={t3}>{children}</GoogleMapsContext.Provider>;
    $[7] = children;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export function useGoogleMaps() {
  const context = useContext(GoogleMapsContext);
  if (context === null) {
    throw new Error("useGoogleMaps must be used within a GoogleMapsProvider");
  }
  return context;
}